import React, { useMemo } from 'react';
import { useObjectContext } from '@/hooks/useObjectContext';
import { formatCurrency } from '@/utils/constants';
import { HeaderDetail } from './HeaderDetail';

export const PolicyTotal = () => {
	const { dealRow } = useObjectContext();

	const calculatedPolicyTotal = useMemo(() => {
		const policies = dealRow?.policies || [];
		return policies.reduce((sum, policy) => sum + (policy.amount || 0), 0);
	}, [dealRow?.policies]);

	return (
		<HeaderDetail label='Policy Total'>
			{formatCurrency({
				num: calculatedPolicyTotal,
				showDecimal: true,
			})}
		</HeaderDetail>
	);
};
